import React, { PureComponent } from 'react';

import { Loader, Root } from './styles';

export default class LocalLoader extends PureComponent {
    render() {
        const { active, children, className, main, fullHeight, dark } = this.props;
        return active === true ? (
            <Loader
                className={className}
                active={active}
                dark={dark}
                main={main}
                fullHeight={fullHeight}
            />
        ) : (
            <Root className={className}>{children}</Root>
        );
    }
}
